module.exports = __webpack_public_path__ + "static/media/t.475682ea.obj";